import autobind from 'class-autobind';
import isEqual from 'lodash/isEqual';

import { PRESET_REDUCTION_RECALC } from 'atg/constants/BetUpdateType';
import { PresetReductionDefaults } from 'atg/constants/PresetReduction';
import { getText } from 'shared/utils/Text';

import BaseView from './BaseView';

export default class PresetReductionView extends BaseView {
  constructor() {
    super(...arguments);
    autobind(this, PresetReductionView.prototype);
  }

  betInformation = this.getAPI().betInformation;

  getGridClass = () => 'view-preset-reduction';
  getViewTitle = () => getText('view-preset-reduction');
  getMenuTitle = () => getText('view-preset-reduction');
  getItem = () => this;
  getClass = () => PresetReductionView;

  getBottomInfoHidden = () => true;
  getMenuTogglable = () => true;
  getMenuDeletable = () => true;

  setPresetReduction = presetReduction => {
    this.betInformation.setPresetReduction(presetReduction);
    this.updateBet();
  };

  getDefaults = () => {
    const betKey = this.betInformation.getBetKey();
    const betType = betKey.getBetType();

    return {
      disabled: true,
      ...PresetReductionDefaults[betType],
    };
  };

  getPresetReduction = () =>
    this.betInformation.getPresetReduction() || this.getDefaults();

  toggleItem = () =>
    this.setPresetReduction({
      ...this.getPresetReduction(),
      disabled: !this.isDisabled(),
    });

  deleteItem = () => this.setPresetReduction(this.getDefaults());

  updateBet = () => this.getAPI().scheduleBetUpdate(PRESET_REDUCTION_RECALC);

  isDisabled = () => this.getPresetReduction().disabled;

  getMenuSelected = () =>
    !this.isDisabled() ||
    !isEqual(this.getDefaults(), {
      ...this.getPresetReduction(),
      disabled: true,
    });
}
